import api from '@/api'
import * as types from './types'

export default {
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setFilterBy({
    commit
  }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  async getIntegrationById({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      api.getIntegrationById(id)
        .then(response => {
          commit(types.SET_INTEGRATION, response.data)
          resolve(response)
        })
    })
  },
  async getIntegrations({ commit, dispatch }, searchOptions) {
    console.log(searchOptions.state)
    return new Promise((resolve, reject) => {
      api.getIntegrations(searchOptions)
        .then(response => {
          commit(types.SET_INTEGRATIONS, response.data)
          resolve(response)
        })
    })
  },
  async updateIntegration({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.updateIntegration(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async RequeueIntegration({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.requeueIntegrationById(data)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/integrations/actions.js